import { MenuItem } from '@mui/material'
import { ApproveWithCommentTaskDialog } from 'components/pages/task/details/task-content-v2/common/ApproveWithCommentTaskDialog'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import React, { FC } from 'react'
import { useIntl } from 'react-intl'

type ApproveWithCommentDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const ApproveWithCommentDropdownOption: FC<ApproveWithCommentDropdownOptionProps> = ({ task, close }) => {
    const intl = useIntl()
    const { open } = useSimpleModal()
    const handleClick = (): void => {
        open(ApproveWithCommentTaskDialog, { task })()
        close()
    }

    let label: string
    switch (task.type?.taskType.oneofKind) {
        case 'certify':
            label = intl.formatMessage({
                id: 'component_task_list_certify_comment_option_label',
                defaultMessage: 'Certify with comment',
            })
            break
        case 'revoke':
            label = intl.formatMessage({
                id: 'component_task_list_confirm_comment_option_label',
                defaultMessage: 'Confirm with comment',
            })
            break
        case 'grant':
        default:
            // This is more generic
            label = intl.formatMessage({
                id: 'component_task_list_approve_comment_option_label',
                defaultMessage: 'Approve with comment',
            })
            break
    }

    return (
        <MenuItem onClick={handleClick} key={`components_task_actions_dropdown_approve_with_comment_task_${task.id}`}>
            {label}
        </MenuItem>
    )
}
